import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useSimpleToggle } from '../../../../../hooks/use-simple-toggle';
import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.less';

const maxToShow = 6;

export const RemainingCsvColumns = () => {
  const [showWithLimit, toggleLimit] = useSimpleToggle(true);

  const { remainingColumns } = useImportContext();

  const remainingColumnsLength = remainingColumns.length;

  if (!remainingColumnsLength) {
    return null;
  }

  const renderRemainingColumns = () => {
    const colsToShow = showWithLimit ? remainingColumns.slice(0, maxToShow) : remainingColumns;
    const lastIndexOfCol = colsToShow.length - 1;

    return colsToShow.map((column, index) => {
      const separator = index < lastIndexOfCol ? ', ' : '';

      return (
        <span key={column} className={styles['remaining-column']}>
          {`${column}${separator}`}
        </span>
      );
    });
  };

  return (
    <div className={styles['warning-message']}>
      <div className={styles['warning-info']}>
        <FontAwesomeIcon className={styles['info-icon']} icon={faInfoCircle} />
        <FormattedMessage {...messages.warningMessage} values={{ amount: remainingColumnsLength }} />
      </div>
      {renderRemainingColumns()}
      {remainingColumnsLength > maxToShow && (
        <Button className={styles['hide-more-btn']} onClick={toggleLimit} theme='unstyled'>
          <FormattedMessage {...(showWithLimit ? messages.showMoreColumns : messages.hideMoreColumns)} />
        </Button>
      )}
    </div>
  );
};
